// extracted by mini-css-extract-plugin
module.exports = {"modalBase":"modal-base_modalBase__2r876"};